import { render, staticRenderFns } from "./ItemsNeededModal.vue?vue&type=template&id=3d8d81b4"
import script from "./ItemsNeededModal.vue?vue&type=script&lang=js"
export * from "./ItemsNeededModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports